import React, { useState } from "react";
import { AssessmentHeader } from "../components/ui/assessments/assessments-header";
import { AssessmentCard } from "../components/ui/assessments/assessment-card";
import { Sidebar } from "../components/ui/sidebar";
import { UniversalSearch } from "../components/ui/universal-search";
import {AIChatBox} from "../components/ui/ai-chat-box";
import ProtectedRoute from "../components/ProtectedRoute";

const assessments = [
  {
    id: 1,
    title: "Space Explorer Quiz",
    description: "Test your knowledge about planets, stars, and galaxies. Are you a future astronaut?",
    tags: [
      { label: "Science", variant: "science" },
      { label: "Logic", variant: "logic" },
    ],
    duration: "15 min",
    questionCount: 20,
    backgroundColor: "bg-red-50",
    borderColor: "border-red-200",
    demoQuestions: [
      "I enjoy learning about planets and their characteristics",
      "I can easily remember facts about different galaxies",
      "I find black holes and space phenomena fascinating",
      "I would enjoy working with telescopes and space technology",
      "I like solving problems related to space and physics",
    ],
    icon: (
      <div className="w-100 h-100 flex items-center justify-center">
        <img
          src="/space-explorer.png"
          alt="Space Explorer"
          width={250}
          height={250}
          className="object-contain"
        />
      </div>
    ),
  },
  {
    id: 2,
    title: "Creative Canvas",
    description: "Unleash your inner artist! This quiz helps you find what type of creative you are.",
    tags: [
      { label: "Art", variant: "art" },
      { label: "Personality", variant: "personality" },
    ],
    duration: "10 min",
    questionCount: 15,
    backgroundColor: "bg-indigo-100",
    borderColor: "border-indigo-200",
    demoQuestions: [
      "I enjoy expressing myself through drawing or painting",
      "I often come up with creative solutions to problems",
      "I find inspiration in everyday objects and scenes",
      "I like experimenting with different art styles and techniques",
      "I feel energized when working on creative projects",
    ],
    icon: (
      <div className="w-100 h-100 flex items-center justify-center">
        <img
          src="/creative-canvas.png"
          alt="Creative Canvas"
          width={250}
          height={250}
          className="object-contain"
        />
      </div>
    ),
  },

   {
    id: 3,
    title: "Math Magician",
    description: "From tricky puzzles to fun number games, see if you have what it takes to be a math wizard.",
    tags: [
      { label: "Math", variant: "math" },
      { label: "Logic", variant: "logic" },
    ],
    duration: "20 min",
    questionCount: 25,
    backgroundColor: "bg-emerald-50",
    borderColor: "border-emerald-200",
    demoQuestions: [
      "I enjoy solving complex mathematical problems",
      "Numbers and patterns come naturally to me",
      "I like finding logical solutions to puzzles",
      "I feel confident working with equations and formulas",
      "I enjoy games that involve strategic thinking and calculation"
    ],
    icon: (
      <div className="w-100 h-100 flex items-center justify-center">
        <img 
          src="/maths-detective.png" 
          alt="Space Explorer" 
          width={250} 
          height={250}
          className="object-contain"
        />
      </div>
    )
  },

    {
    id: 4,
    title: "Team Player Test",
    description: "Do you like working with others? Find out your collaboration style and strengths.",
    tags: [
      { label: "Personality", variant: "personality" },
      { label: "Social", variant: "social" },
    ],
    duration: "12 min",
    questionCount: 18,
    backgroundColor: "bg-rose-50",
    borderColor: "border-rose-200",
    demoQuestions: [
      "I enjoy collaborating with others on group projects",
      "I'm good at listening to different perspectives",
      "I feel comfortable taking on leadership roles in teams",
      "I can adapt my communication style to work well with different people",
      "I believe teamwork leads to better results than working alone"
    ],
    icon: (
       <div className="w-100 h-100 flex items-center justify-center">
        <img 
          src="/team-player.png" 
          alt="Space Explorer" 
          width={250} 
          height={250}
          className="object-contain"
        />
      </div>
    )
  },
  {
    id: 5,
    title: "Code Cracker Challenge",
    description: "Solve logic puzzles and see if you have the mind of a programmer. No coding required!",
    tags: [
      { label: "Technology", variant: "technology" },
      { label: "Logic", variant: "logic" },
    ],
    duration: "25 min",
    questionCount: 15,
    backgroundColor: "bg-indigo-100",
    borderColor: "border-indigo-200",
    demoQuestions: [
      "I enjoy breaking down complex problems into smaller steps",
      "I can easily spot patterns in sequences and data",
      "I like thinking about how systems and processes work",
      "I enjoy puzzles that require logical step-by-step thinking",
      "I'm curious about how software and apps are built"
    ],
    icon: (
      <div className="w-100 h-100 flex items-center justify-center">
        <img 
          src="/code.png" 
          alt="Space Explorer" 
          width={200} 
          height={200}
          className="object-contain"
        />
      </div>
    )
  },
  {
    id: 6,
    title: "Nature Detective",
    description: "Explore the wonders of the animal kingdom and plant life. How much do you know about Earth?",
    tags: [
      { label: "Nature", variant: "nature" },
      { label: "Science", variant: "science" },
    ],
    duration: "10 min",
    questionCount: 22,
    backgroundColor: "bg-lime-50",
    borderColor: "border-lime-200",
    demoQuestions: [
      "I enjoy learning about different animal species and their habitats",
      "I can identify many types of plants and trees",
      "I find environmental science and conservation interesting",
      "I enjoy spending time outdoors observing nature",
      "I'm curious about ecosystems and how living things interact"
    ],
    icon: (
      <div className="w-100 h-100 flex items-center justify-center">
        <img 
          src="/nature.png" 
          alt="Space Explorer" 
          width={250} 
          height={250}
          className="object-contain"
        />
      </div>
    )
  },

];

const ratingOptions = [
  { value: "very_sure", label: "Very Sure" },
  { value: "sure", label: "Sure" },
  { value: "maybe", label: "Maybe" },
  { value: "no", label: "No" },
  { value: "not_at_all", label: "Not At All" },
];

export default function AssessmentsPage() {
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [showDemo, setShowDemo] = useState(false);
  const [currentDemoQuestion, setCurrentDemoQuestion] = useState(0);
  const [demoAnswers, setDemoAnswers] = useState({});
  const [showDemoResults, setShowDemoResults] = useState(false);

  const handleStartAssessment = (id) => {
    setSelectedAssessment(id);
    setShowDemo(true);
    setCurrentDemoQuestion(0);
    setDemoAnswers({});
    setShowDemoResults(false);
  };

  const handleCloseDemo = () => {
    setShowDemo(false);
    setSelectedAssessment(null);
    setCurrentDemoQuestion(0);
    setDemoAnswers({});
    setShowDemoResults(false);
  };

  const handleDemoAnswer = (value) => {
    setDemoAnswers((prev) => ({
      ...prev,
      [currentDemoQuestion]: value,
    }));

    const currentAssessment = assessments.find((a) => a.id === selectedAssessment);
    if (currentAssessment && currentDemoQuestion < currentAssessment.demoQuestions.length - 1) {
      setTimeout(() => setCurrentDemoQuestion((prev) => prev + 1), 300);
    } else {
      setTimeout(() => setShowDemoResults(true), 500);
    }
  };

  const handleRestartDemo = () => {
    setCurrentDemoQuestion(0);
    setDemoAnswers({});
    setShowDemoResults(false);
  };

  const getSelectedAssessment = () => assessments.find((a) => a.id === selectedAssessment);

  const calculateDemoScore = () => {
    const scores = {
      very_sure: 5,
      sure: 4,
      maybe: 3,
      no: 2,
      not_at_all: 1,
    };
    const totalScore = Object.values(demoAnswers).reduce(
      (sum, answer) => sum + (scores[answer] || 0),
      0
    );
    const maxScore = getSelectedAssessment()?.demoQuestions.length * 5 || 1;
    return Math.round((totalScore / maxScore) * 100);
  };

  const handleSearch = (query) => {
    console.log("Universal search for:", query);
  };

  return (
  <ProtectedRoute>
     <div className="flex min-h-screen bg-slate-200">
      {/* Sidebar */}
      <Sidebar />

      <AIChatBox />

      {/* Universal Search */}
      <UniversalSearch onSearch={handleSearch} />

      <div className="flex-1 lg:ml-64 flex flex-col">
        <main className="flex-1 p-3 sm:p-4 md:p-6 lg:p-8">
          {/* Mobile Header */}
          <div className="md:hidden flex items-center gap-3 mb-4 pb-4 border-b border-slate-200 bg-white p-4 rounded-lg">
            <button
              onClick={() => document.dispatchEvent(new CustomEvent("toggle-sidebar"))}
              className="p-2 rounded-lg bg-slate-100 hover:bg-slate-200 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
            >
              <svg className="w-6 h-6 text-slate-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <div className="flex-1">
              <h1 className="text-lg font-bold text-slate-900">Assessments</h1>
              <p className="text-sm text-slate-600">Test your knowledge and skills</p>
            </div>
          </div>

          <div className="max-w-6xl mx-auto w-full">
            {/* Desktop Header */}
            <div className="hidden md:block mb-6 sm:mb-8">
              <AssessmentHeader userName="Alex" />
            </div>

            {/* Assessments Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
              {assessments.map((assessment) => (
                <AssessmentCard
                  key={assessment.id}
                  title={assessment.title}
                  description={assessment.description}
                  tags={assessment.tags}
                  duration={assessment.duration}
                  questionCount={assessment.questionCount}
                  backgroundColor={assessment.backgroundColor}
                  borderColor={assessment.borderColor}
                  icon={assessment.icon}
                  onStart={() => handleStartAssessment(assessment.id)}
                />
              ))}
            </div>
          </div>
        </main>

        {/* Demo Modal */}
        {showDemo && getSelectedAssessment() && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h2 className="text-2xl font-bold text-slate-900">
                      {getSelectedAssessment()?.title}
                    </h2>
                    <p className="text-slate-600">Demo Questions</p>
                  </div>
                  <button
                    onClick={handleCloseDemo}
                    className="p-2 rounded-lg hover:bg-slate-100 transition-colors"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                {/* Progress */}
                {!showDemoResults && (
                  <div className="mb-6">
                    <div className="flex justify-between text-sm text-slate-600 mb-2">
                      <span>
                        Question {currentDemoQuestion + 1} of {getSelectedAssessment()?.demoQuestions.length}
                      </span>
                      <span>
                        {Math.round(
                          ((currentDemoQuestion + 1) / (getSelectedAssessment()?.demoQuestions.length || 1)) * 100
                        )}
                        %
                      </span>
                    </div>
                    <div className="w-full bg-slate-200 rounded-full h-2">
                      <div
                        className="bg-indigo-600 h-2 rounded-full transition-all duration-300"
                        style={{
                          width: `${((currentDemoQuestion + 1) / (getSelectedAssessment()?.demoQuestions.length || 1)) * 100}%`,
                        }}
                      ></div>
                    </div>
                  </div>
                )}

                {/* Demo Questions */}
                {!showDemoResults && (
                  <div className="space-y-6">
                    <div className="bg-white p-6 rounded-lg border border-slate-200">
                      <h3 className="text-lg font-semibold text-slate-900 mb-4">
                        {getSelectedAssessment()?.demoQuestions[currentDemoQuestion]}
                      </h3>
                      <p className="text-sm text-slate-600 mb-6">How well does this describe you?</p>

                      <div className="grid grid-cols-1 gap-3">
                        {ratingOptions.map((option) => (
                          <button
                            key={option.value}
                            onClick={() => handleDemoAnswer(option.value)}
                            className="p-4 text-left rounded-lg border border-slate-200 hover:border-indigo-300 hover:bg-indigo-50 transition-all duration-200"
                          >
                            <div className="flex items-center gap-3">
                              <span className="font-medium text-slate-900">{option.label}</span>
                            </div>
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Demo Results */}
                {showDemoResults && (
                  <div className="text-center py-8">
                    <div className="text-6xl mb-6">🎉</div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-4">Demo Complete!</h3>
                    <p className="text-slate-600 mb-6">Based on your answers, you scored:</p>

                    <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-6 mb-6">
                      <div className="text-3xl font-bold text-indigo-700 mb-2">{calculateDemoScore()}%</div>
                      <div className="text-indigo-600">
                        Compatibility with {getSelectedAssessment()?.title}
                      </div>
                    </div>

                    <p className="text-slate-600 mb-8">
                      Ready to take the full assessment with {getSelectedAssessment()?.questionCount} questions?
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                      {/* <button
                        onClick={() => console.log(`Starting full assessment: ${selectedAssessment}`)}
                        className="px-6 py-3 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700 transition-colors"
                      >
                        Start Full Assessment
                      </button> */}
                      <button
                        onClick={handleRestartDemo}
                        className="px-6 py-3 bg-indigo-600 text-slate-100 rounded-lg font-semibold border border-slate-300 hover:bg-indigo-500 transition-colors"
                      >
                        Retake Assessment Test
                      </button>
                      <button
                        onClick={handleCloseDemo}
                        className="px-6 py-3 bg-white text-slate-700 rounded-lg font-semibold border border-slate-300 hover:bg-slate-50 transition-colors"
                      >
                        Back to Assessments
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  </ProtectedRoute>
  );
}